var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('v-btn',{attrs:{"to":{ name: 'home' },"color":"primary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-home")]),_vm._v(" home ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }